import { createContext } from 'react';
export var WizardContext = createContext({
    currentStep: '',
    nextStep: function () { return void 0; },
    prevStep: function () { return void 0; },
    isFirstStep: true,
    isLastStep: false,
});
